export default class SnUserExists {
  constructor (data = {}) {
    this.exists = !!data.exists
    this.incomplete = !!data.incomplete
    Object.freeze(this)
  }
}
